import { LogoutSection } from './styled';

function index(props) {
  const { showButton, handleLogout } = props;
  return showButton ? (
    <LogoutSection onClick={handleLogout}>Logout</LogoutSection>
  ) : (
    <></>
  );
}

export default index;
